<template lang="pug">
  .component-backoffice-create-vehicle-slot
    modal-reveal(sizing="small", ref="createVehicleSlotModal")
      button.button.small(slot="trigger") Add to Parking Lot
      h2 Add V{{item.id}} to a parking
      .row
        .column
          label Vehicle Slot name
            input(type="text", v-model="body.name")
          BookingModeSelect(v-model="body.booking_mode")
        .column
          selectize-grouped-parking-assets(@parkingSlotSelected="setParkingSlot")
      .row.column
        button.button(:disabled="!body.parking_slot_id || !body.booking_mode", @click="createVehicleSlot") Create

</template>

<script>
  import ModalReveal from "../../../foundation/ModalReveal";
  import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
  import MaggieHelper from "../../../../../maggieHelper";
  import SelectizeGroupedParkingAssets from "../../lists/selectize/SelectizeGroupedParkingAssets";
  import BookingModeSelect from '../../../BookingModeSelect'

  export default {
    name: "CreateVehicleSlot",
    components: {BookingModeSelect, SelectizeGroupedParkingAssets, ModalReveal},
    created() {
      this.body.vehicle_id = this.item.id

    },
    data() {
      return {
        parkinSlot: null,
        body: {
          name: `${this.item.brand} ${this.item.model} ${this.item.plate}`,
          parking_slot_id: null,
          booking_mode: 'RT',
          vehicle_id: null,
        }
      }
    },
    methods: {
      createVehicleSlot() {
        this.body.name = `${this.parkingSlot.name}-${this.item.model} ${this.item.plate}`
        KeplerBackofficeSdk.vehicleSlots.make(this.body, (data) => {
          this.$refs.createVehicleSlotModal.close()
          MaggieHelper.notification('slot-create', 'Vehicle slot created sucessfully')
          this.$emit('update')
        })
      },
      setParkingSlot(val) {
        this.body.parking_slot_id = val.id
        this.parkingSlot = val
      }
    },
    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CreateVehicleSlot.vue?056e80f1